import 'regenerator-runtime/runtime'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import 'normalize.css/normalize.css'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
// 在 main.js 或 main.ts 中确认是否引入了样式
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'
import './assets/main.scss'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'


import 'highlight.js/styles/stackoverflow-dark.css'
import hljs from 'highlight.js/lib/core';
import hjson from 'highlight.js/lib/languages/json'
import hshell from 'highlight.js/lib/languages/shell'
import hbash from 'highlight.js/lib/languages/bash'
import hljsVuePlugin from "@highlightjs/vue-plugin";

hljs.registerLanguage('json', hjson)
hljs.registerLanguage('shell', hshell)
hljs.registerLanguage('bash', hbash)


import App from './App.vue'
import router from './router'
import "@/permission"

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(ElementPlus, {
  locale: zhCn,
  size: 'default'
})
app.use(hljsVuePlugin)

app.mount('#app')

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 激活暗黑模式
document.documentElement.classList.add('dark')

